export const cidt = [
    {
        'encabezado': [
            {
                'header': 'El CIDT es un espacio de 4.5 hectareas de cultivos experimentales donde se realiza investigación dirigida a temas agrícolas de relevancia para el Estado de Hidalgo. Se encuentra ubicado en la Carretera Mixquiahuala-Tezontepec Km 3.5, Mixquiahuala de Juárez, Hidalgo.' 
            },
            {
                'header': 'El CIDT forma parte de la estructura de la Secretaría de Agricultura y Desarrollo Rural del Estado de Hidalgo (SADERH), desde donde es administrado y dirigido.'
            }

        ],        

        'silde': [
            {
                'img': '/img/Cidt/cidt3.png',
            },
            {
                'img': '/img/Cidt/cidt4.png',
            }
            ,
            {
                'img': '/img/Cidt/cidt5.png',
            }           
        ],

        'parrafo':'Actualmente y bajo un esquema de colaboración con instituciones de liderazgo mundial como lo es el Centro Internacional de Mejoramiento de Maíz y Trigo (CIMMYT), la SADERH a través del CIDT está trabajando en la estrategia del Gobierno del Estado para la erradicación de la pobreza y el fortalecimiento de las acciones en seguridad alimentaria; con la firma del convenio entre la SADERH y el CIMMYT se instaura el programa MasAgro Hidalgo, donde se establecen compromisos para generar soluciones a las necesidades de nuevas tecnologías sustentables, en beneficio de productores hidalguenses.',
        'parrafo2':'El CIDT forma parte de la red de 8 plataformas del CIMMYT denominada “Valles Altos”, ubicadas en los Estados de Hidalgo, México y Puebla. Estas plataformas contribuyen a mejorar la vida de los productores desarrollando investigación agrícola para combatir la pobreza por carencia alimentaria, la desnutrición, el cambio climático y la degradación del medio ambiente.',
        'objetivos':[
            {
                'objetivo': 'Responder a las necesidades de investigación, validación, capacitación y trasferencia de tecnología que demandan los pequeños productores en la región del Valle del Mezquital.',     
                'icon': '/img/icons/objetivo.png'  
            },
            {
                'objetivo': 'Generar conocimientos científicos y tecnológicos para ser aplicados de manera sustentable y acorde a los recursos disponibles de los productores en aras de incrementar la productividad del campo hidalguense.',
                'icon': '/img/icons/mision.png'
            },
            {
                'objetivo': 'Consolidarse como un Centro de Investigación y Desarrollo Tecnológico líder en la región, con capacidad de atender las necesidades de los productores agrícolas hidalguenses.',
                'icon': '/img/icons/vision.png'
            }
        ],

        'slidee': [
            {
                'img_slidee': '/img/Cidt/cidt2.png',
            },         
        ],
        
       


        

    }
]